var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAddDatefinder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "17px",
    viewBox: "0 0 20 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icAddDatefinder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.9328,4.24 L11.644375,4.24 L11.644375,6.08093165 C11.644375,6.68303122 11.183125,7.16455696 10.604,7.16455696 L10.276,7.16455696 C9.696875,7.16455696 9.235625,6.68328776 9.235625,6.08093165 L9.235625,4.24 L5.289375,4.24 L5.289375,6.08093165 C5.289375,6.68303122 4.8194125,7.16455696 4.2408,7.16455696 L3.9128,7.16455696 C3.3341875,7.16455696 2.855,6.68328776 2.855,6.08093165 L2.855,4.24 L1.3872,4.24 C0.9541375,4.24 0.6,4.61839662 0.6,5.06888101 L0.6,15.5808675 C0.6,16.0313519 0.9541375,16.4 1.3872,16.4 L12.9328,16.4 C13.3658625,16.4 13.72,16.0313519 13.72,15.5808675 L13.72,5.06888101 C13.72,4.61839662 13.3658625,4.24 12.9328,4.24 Z M12.618125,14.6940084 C12.6171402,15.0123863 12.3595804,15.2702377 12.0415625,15.2712236 L2.2784375,15.2712236 C1.96041963,15.2702377 1.7028598,15.0123863 1.701875,14.6940084 L1.701875,8.7935865 C1.7028598,8.47520862 1.96041963,8.21735722 2.2784375,8.21637131 L12.0415625,8.21637131 C12.3595804,8.21735722 12.6171402,8.47520862 12.618125,8.7935865 L12.618125,14.6940084 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.98505763,6.8 C3.7095322,6.8 3.48,6.51104478 3.48,6.16351045 L3.48,3.90913433 C3.48,3.56212537 3.7095322,3.28 3.98505763,3.28 L4.26275254,3.28 C4.53827797,3.28 4.76,3.56212537 4.76,3.90913433 L4.76,6.16324776 C4.76,6.51104478 4.53827797,6.8 4.26275254,6.8 L3.98505763,6.8 Z M10.2440218,6.8 C9.96374592,6.8 9.74526316,6.51104478 9.74526316,6.16324776 L9.74526316,3.90887164 C9.74526316,3.56212537 9.96374592,3.28 10.2440218,3.28 L10.5265045,3.28 C10.8067804,3.28 11.0252632,3.56212537 11.0252632,3.90887164 L11.0252632,6.16324776 C11.0252632,6.51104478 10.8067804,6.8 10.5265045,6.8 L10.2440218,6.8 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.84,9.36 L5.08,9.36 L5.08,11.36 L2.84,11.36 L2.84,9.36 Z M2.84,12.16 L5.08,12.16 L5.08,14.16 L2.84,14.16 L2.84,12.16 Z M6.09818182,9.36 L8.33818182,9.36 L8.33818182,11.36 L6.09818182,11.36 L6.09818182,9.36 Z M6.09818182,12.16 L8.33818182,12.16 L8.33818182,14.16 L6.09818182,14.16 L6.09818182,12.16 Z M9.56,9.36 L11.8,9.36 L11.8,11.36 L9.56,11.36 L9.56,9.36 Z M9.56,12.16 L11.8,12.16 L11.8,14.16 L9.56,14.16 L9.56,12.16 Z",
    id: "path-5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Members-Empty-state",
    transform: "translate(-124.000000, -2513.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(17.000000, 2306.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/buttons/pill",
    transform: "translate(87.000000, 201.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icAddDatefinder",
    transform: "translate(20.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#7BCB45",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#7BCB45",
    fillRule: "nonzero",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#7BCB45",
    fillRule: "nonzero",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2374333,2.61027777 L17.7625667,2.61027777 L17.7625667,0.889640325 C17.7625667,0.398380643 17.42123,0 17,0 C16.57877,0 16.2374333,0.398380643 16.2374333,0.889640325 L16.2374333,2.61027777 L14.7625667,2.61027777 C14.3413367,2.61027777 14,3.00865841 14,3.4999181 C14,3.99117778 14.3413367,4.38955842 14.7625667,4.38955842 L16.2374333,4.38955842 L16.2374333,6.11035968 C16.2374333,6.60161936 16.57877,7 17,7 C17.42123,7 17.7625667,6.60161936 17.7625667,6.11035968 L17.7625667,4.38972223 L19.2374333,4.38972223 C19.6586633,4.38972223 20,3.99134159 20,3.5000819 C20,3.00865841 19.6586633,2.61027777 19.2374333,2.61027777 Z",
    id: "Shape",
    fill: "#7BCB45",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddDatefinder);
export default __webpack_public_path__ + "static/media/icAddDatefinder.89ac0e6d9f60ce718f5aeadf748b9595.svg";
export { ForwardRef as ReactComponent };